import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ApplicationsIdSchema } from '../applications.schema';
import {
  ApplicationScanEffortSchema,
  TenantScanEffortOverrideSchema,
  UpdateApplicationScanEffortBodySchema,
  UpdateTenantScanEffortOverrideBodySchema,
} from './scan-effort.schema';

export const scanEffortContractRoutes = {
  getApplicationScanEffort: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/{id}/scan-effort',
      summary: 'Get the scan effort level for an application',
      description:
        'Returns the application effort level, the tenant-wide override (if any), and the effective level used for attacks and deep scans.',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationsIdSchema }))
    .output(ApplicationScanEffortSchema),
  updateApplicationScanEffort: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_AI_CAPACITY.name],
    })
    .route({
      method: 'PUT',
      path: '/{id}/scan-effort',
      summary: 'Set the scan effort level for an application',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: UpdateApplicationScanEffortBodySchema,
      }),
    )
    .output(ApplicationScanEffortSchema),
  getTenantScanEffortOverride: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/license/scan-effort-override',
      summary: 'Get the tenant-wide scan effort override',
      inputStructure: 'detailed',
    })
    .output(TenantScanEffortOverrideSchema),
  updateTenantScanEffortOverride: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_AI_CAPACITY.name],
    })
    .route({
      method: 'PUT',
      path: '/license/scan-effort-override',
      summary: 'Set or clear the tenant-wide scan effort override',
      description:
        'When set, the override applies to every application in the tenant and takes precedence over per-application effort levels. Send null to clear it.',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: UpdateTenantScanEffortOverrideBodySchema }))
    .output(TenantScanEffortOverrideSchema),
};
